export type WorkspacePreparationError =
  | { kind: 'self-referral' }
  | { kind: 'other'; message: string | null };

// The current API returns a generic BAD_REQUEST with this message, not a
// dedicated self-referral code. Keep the compatibility match in one place.
const SELF_REFERRAL_MESSAGE =
  'You cannot use a referral link that you created. Continue onboarding without a referral.';

export function resolveWorkspacePreparationError(error: unknown): WorkspacePreparationError {
  const failure = error as {
    message?: unknown;
    response?: { message?: unknown; data?: { message?: unknown } };
  } | null;
  const messages = [failure?.message, failure?.response?.message, failure?.response?.data?.message];
  if (messages.some(message => typeof message === 'string' && message.trim() === SELF_REFERRAL_MESSAGE)) {
    return { kind: 'self-referral' };
  }
  return {
    kind: 'other',
    message: typeof failure?.message === 'string' && failure.message.trim() ? failure.message : null,
  };
}

export function formatWorkspacePreparationError(
  error: WorkspacePreparationError | null,
  t: (key: string) => string,
): string | null {
  if (!error) return null;
  if (error.kind === 'self-referral') return t('website.onboarding.common.selfReferral');
  return error.message || t('website.onboarding.common.prepareWorkspaceFailed');
}
